import { render } from "./NewCertificateDialogExternalStallionTab.vue?vue&type=template&id=38a29756"
import script from "./NewCertificateDialogExternalStallionTab.vue?vue&type=script&lang=js"
export * from "./NewCertificateDialogExternalStallionTab.vue?vue&type=script&lang=js"

import "./NewCertificateDialogExternalStallionTab.vue?vue&type=style&index=0&id=38a29756&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__